module.exports = __webpack_public_path__ + "img/car-safety-bottom.435fcbe2.png";